export const FEEDBACK_MODAL_TITLE = 'Оставьте отзыв';
export const FEEDBACK_MODAL_TEXT =
  'Оцените и напишите свои впечатления о качестве работы специалиста.';
export const FEEDBACK_COMMENT_MAX_LENGTH = 2000;

export const FEEDBACK_SUCCESS_TITLE = 'Спасибо за отзыв!';
export const FEEDBACK_SUCCESS_TEXT = 'Совсем скоро он будет опубликован';

export const FEEDBACK_ALREADY_EXIST_STATUS = 409;

const FEEDBACK_ERRORS: Record<number, string> = {
  401: 'Неверный код из SMS, запросите новый и повторите попытку',
  [FEEDBACK_ALREADY_EXIST_STATUS]: 'Вы уже оставили отзыв об исполнителе',
  429: 'Слишком много запросов, попробуйте позже.',
  500: 'Поле код из SMS не может быть пустым.',
};

const DEFAULT_ERROR = 'Что-то пошло не так, попробуйте позже.';

export const getFeedbackErrorMessage = (status: number): string =>
  FEEDBACK_ERRORS[status] ?? DEFAULT_ERROR;

export const FEEDBACK_CONNECTED_TEXT = 'Клиент обращался через Юрик.ру';
